import { useEffect, useRef } from 'react';
import styles from './VinylAlbum.module.css';

function VinylAlbum({ image, alt, isPlaying, onClick, albumRef, delay }) {
  const canvasRef = useRef(null);
  const ripplesRef = useRef([]);
  const animationRef = useRef(null);
  const startLoopRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    canvas.width = 220;
    canvas.height = 220;

    const loop = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ripplesRef.current = ripplesRef.current.filter(r => r.opacity > 0);

      if (ripplesRef.current.length === 0) {
        animationRef.current = null;
        return;
      }

      ripplesRef.current.forEach(r => {
        const progress = r.radius / r.maxRadius;
        r.radius += 2.5;
        r.opacity = 0.7 * (1 - progress);

        ctx.beginPath();
        ctx.arc(r.x, r.y, r.radius, 0, Math.PI * 2);
        ctx.strokeStyle = `rgba(150, 210, 255, ${r.opacity})`;
        ctx.lineWidth = r.width;
        ctx.stroke();

        if (r.radius > 20) {
          ctx.beginPath();
          ctx.arc(r.x, r.y, r.radius * 0.65, 0, Math.PI * 2);
          ctx.strokeStyle = `rgba(200, 230, 255, ${r.opacity * 0.4})`;
          ctx.lineWidth = r.width * 0.5;
          ctx.stroke();
        }
      });

      animationRef.current = requestAnimationFrame(loop);
    };

    startLoopRef.current = () => {
      if (!animationRef.current) {
        animationRef.current = requestAnimationFrame(loop);
      }
    };

    return () => cancelAnimationFrame(animationRef.current);
  }, []);

  const triggerWater = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const cx = canvas.width / 2;
    const cy = canvas.height / 2;

    for (let i = 0; i < 4; i++) {
      setTimeout(() => {
        ripplesRef.current.push({
          x: cx,
          y: cy,
          radius: 10,
          maxRadius: 90 + i * 15,
          opacity: 0.7,
          width: 2 - i * 0.3,
        });
        if (startLoopRef.current) startLoopRef.current();
      }, i * 80);
    }
  };

  const handleClick = () => {
    triggerWater();
    onClick();
  };

  return (
    <div
      className={styles.wrapper}
      ref={albumRef}
      style={{ '--delay': delay }}
      onClick={handleClick}
    >
      <div className={`${styles.disc} ${isPlaying ? styles.spinning : ''}`}>
        <img src={image} alt={alt} className={styles.cover} />
        <div className={styles.vinylRings}>
          {[...Array(6)].map((_, i) => (
            <div key={i} className={styles.ring} style={{ '--ring-index': i }} />
          ))}
          <div className={styles.hole} />
        </div>
      </div>

      <canvas ref={canvasRef} className={styles.smokeCanvas} />
    </div>
  );
}

export default VinylAlbum;